<template>
    <div id="addworkshop">
        <div>tambah {{isDataWorkshop}}<br> tahapan {{isProductionWorkshop}}<br> detail{{isDetailWorkshop}}<br> tahapan dari detail{{isSetTahapanWorkshop}}</div>
            <ProductionWorkshop v-if="isProductionWorkshop" v-on:showDataWorkshop="showdataworkshop"
                                 v-on:PostWorkshop="Post" v-on:backtolist="backtolist"
                                v-on:gotodetail="showdetailworkshop"/>
            <DetailWorkshop v-if="isDetailWorkshop"  v-bind:datalistworkshop="datalistworkshop"
                            v-on:backtolist="backtolist" v-on:TahapanWorkshop="showProsestahapanworkshop"
                            v-bind:datadetailworkshop="datadetailworkshop" ref="detailworkshopref"/>
            <SetTahapanWorkshop v-if="isSetTahapanWorkshop" v-bind:datalistworkshop="datalistworkshop" v-on:backtodetail="showdetailworkshop"/>
    </div>

</template>

<script>
    import DataWorkshop from "./onboarding/Create Workshop/DataWorkshop";
    import ProductionWorkshop from "./onboarding/Create Workshop/ProductionWorkshop";
    import DetailWorkshop from "./onboarding/Create Workshop/DetailWorkshop";
    import SetTahapanWorkshop from "./onboarding/Create Workshop/SetTahapanWorkshop";
    export default {
        name: "AddWorkshop",
        components: {SetTahapanWorkshop, DetailWorkshop, ProductionWorkshop, DataWorkshop},
        data(){
            return{
                isDataWorkshop:false,
                isProductionWorkshop:false,
                isDetailWorkshop:false,
                isSetTahapanWorkshop:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

                datalistworkshop:{
                    idworkshop:'',
                },

                datadetailworkshop:{
                    workshop: {},

                }
            }
        },
        mounted(){
            // this.showdataworkshop();
            $('#addworkshop').show();
            this.getTahapan()
        },

        methods:{
            backtolist(){
                this.$emit('golistoutlet');
                this.hashworkshop();
                this.dataDataWorkshop.nama='';
                this.dataDataWorkshop.telp='';
                this.dataDataWorkshop.Alamat='';
                this.dataDataWorkshop.selectedkota='1';
                this.dataProductionWorkshop.checklisttahapan=['8000'];
            },

            hashworkshop(){
              this.$emit('hashworkshop')
            },



            showProsestahapanworkshop(idworkshop){
                this.isDataWorkshop=false;
                this.isProductionWorkshop=false;
                this.isDetailWorkshop=false;
                this.isSetTahapanWorkshop=true;
                this.datalistworkshop.idworkshop=idworkshop;
            },




        },
    }
</script>

<style scoped>
    .hidesection {
        display: none;
    }
</style>